import React from 'react';
import useFadeIn from '../hooks/useFadeIn';
import { useLang } from '../LanguageContext';
import './About.css';

const T = {
  heading: { ko: '회사소개', en: 'About Us' },
  desc: {
    ko: <>(주)메디로지스는 스마트 기저귀 센서와 IoT 기술을 결합하여<br />요양시설·재가돌봄 환경에 최적화된 스마트 헬스케어 솔루션을 제공합니다</>,
    en: <>MEDILOGIS combines smart diaper sensors with IoT technology<br />to deliver smart healthcare solutions optimized for care facilities and home care</>,
  },
  cards: [
    {
      title: { ko: '스마트 기저귀 실시간 모니터링', en: 'Real-Time Smart Diaper Monitoring' },
      desc:  { ko: '스마트 기저귀에 부착된 IoT 센서가 24시간 배뇨·배변 상태를 감지하고, 간병인에게 즉시 알림을 전달합니다',
               en: '24/7 IoT sensors on smart diapers detect urination and bowel movements, instantly alerting caregivers.' },
    },
    {
      title: { ko: '헬스케어 데이터 분석', en: 'Healthcare Data Analytics' },
      desc:  { ko: '스마트 기저귀 센서에서 수집된 데이터를 분석하여 개인별 맞춤 케어 패턴을 제공합니다',
               en: 'We analyze data from smart diaper sensors to deliver personalized care patterns for each individual.' },
    },
    {
      title: { ko: '욕창 예방 및 건강 보호', en: 'Bedsore Prevention & Health Care' },
      desc:  { ko: '기저귀 교체 시점을 정확히 알려 욕창·피부염을 예방하고 어르신의 건강을 보호합니다',
               en: 'Precise diaper-change alerts help prevent bedsores and dermatitis, protecting elderly residents’ health.' },
    },
  ],
};

const icons = [
  (<svg viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2"/><path d="M24 14v10l7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>),
  (<svg viewBox="0 0 48 48" fill="none"><path d="M24 4l6 12h13l-10.5 8 4 13L24 29l-12.5 8 4-13L5 16h13z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/></svg>),
  (<svg viewBox="0 0 48 48" fill="none"><path d="M24 44s-16-8.4-16-20.2C8 14.8 15.2 8 24 8s16 6.8 16 15.8C40 35.6 24 44 24 44z" stroke="currentColor" strokeWidth="2"/><path d="M18 22l4 4 8-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>),
];

function About() {
  const ref = useFadeIn();
  const { lang } = useLang();

  return (
    <section className="section about">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">ABOUT US</span>
          <h2>{T.heading[lang]}</h2>
          <p className="section-desc">{T.desc[lang]}</p>
        </div>
        <div className="about-grid" ref={ref}>
          {T.cards.map((card, i) => (
            <div className="about-card" key={i}>
              <div className="about-icon">{icons[i]}</div>
              <h3>{card.title[lang]}</h3>
              <p>{card.desc[lang]}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
